import React from 'react';
import { TertiaryButton, TertiaryButtonProps } from '@workday/canvas-kit-react/button';
import { infoIcon } from '@workday/canvas-system-icons-web';
import styles from './tooltip-button.module.scss';

export function TooltipButton({ children, ...rest }: TertiaryButtonProps) {
    return (
        <TertiaryButton
            className={styles.tooltipButton}
            icon={infoIcon}
            iconPosition='end'
            verticalAlign='middle'
            {...rest}>
            {children}
        </TertiaryButton>
    );
}
